<template>
    <cadastro-simples-form
        endpoint="grupo-conteudo"
        rota-base="/admin/grupo-conteudo"
        titulo-singular="Grupo de Conteúdo"
        :campos-extras='[{"campo":"descricao","label":"Descrição","tipo":"text","span":24}]'>
    </cadastro-simples-form>
</template>

<script>
import CadastroSimplesForm from '@/components/cadastros-auxiliares/cadastro-simples-form.vue'
export default { components: { CadastroSimplesForm } }
</script>
